import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

document.addEventListener('DOMContentLoaded', () => {
    const sliderContainers = document.querySelectorAll('.wp-block-pulp-slider');
    
    sliderContainers.forEach((container) => {
        const swiperEl = container.querySelector('.slider-swiper');
        const prevButton = container.querySelector('.slider-button-prev');
        const nextButton = container.querySelector('.slider-button-next');
        const currentEl = container.querySelector('.slider-counter .current');
        const totalEl = container.querySelector('.slider-counter .total');
        
        if (!swiperEl) return;
        
        const swiper = new Swiper(swiperEl, {
            modules: [Navigation],
            slidesPerView: 1.2,
            spaceBetween: 20,
            navigation: {
                prevEl: prevButton,
                nextEl: nextButton,
            },
            breakpoints: {
                992: {
                    slidesPerView: 2.2,
                    spaceBetween: 30,
                },
            },
            on: {
                init: function() {
                    updateCounter(this);
                },
                slideChange: function() {
                    updateCounter(this);
                    // reset accordions on slide change
                    container.querySelectorAll('.accordion-item[open]').forEach((d) => {
                        d.open = false;
                    });
                    swiperEl.style.paddingBottom = '0px';
                },
            },
        });

        // expand swiper padding-bottom to match the tallest open accordion body
        const accordionItems = container.querySelectorAll('.accordion-item');

        function syncPadding() {
            const open = container.querySelector('.accordion-item[open]');
            const body = open ? open.querySelector('.accordion-body') : null;
            swiperEl.style.paddingBottom = (body ? body.scrollHeight : 0) + 'px';
        }

        accordionItems.forEach((details) => {
            details.addEventListener('toggle', () => {
                // close any other open item first so only one is ever open
                if (details.open) {
                    accordionItems.forEach((other) => {
                        if (other !== details && other.open) other.open = false;
                    });
                }
                syncPadding();
            });
        });
        
        function updateCounter(swiperInstance) {
            if (currentEl && totalEl) {
                const current = swiperInstance.realIndex + 1;
                const total = swiperInstance.slides.length;
                currentEl.textContent = String(current).padStart(2, '0');
                totalEl.textContent = String(total).padStart(2, '0');
            }
        }
    });
});
